/*
 * File: image.ts
 * File Created: 2023-11-27 03:21:15
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:38:32
 * Modified By: Val Liu
 * -----
 */

import { Vue, Component, Prop } from "vue-property-decorator";

/// refined at 2023/12/12
@Component
export default class IVImage extends Vue {
    @Prop({ type: [String, File] })
    src: string | File | undefined;

    @Prop({ type: String, default: "img" })
    tag!: "img" | "div";
}
